import { render, staticRenderFns } from "./data.vue?vue&type=template&id=38bd7756&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "./data.vue?vue&type=style&index=0&id=38bd7756&prod&lang=less&scoped=true"
import style1 from "./data.vue?vue&type=style&index=1&id=38bd7756&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd7756",
  null
  
)

export default component.exports